import React, { useEffect, useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import Select from 'react-select';
import break_box from '../../../../images/product/break_box.png';
import LightGallery from 'lightgallery/react';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import axios from 'axios';

const AddItemQuantity = ({ show, onClose, productData }) => {
  const [categories, setCategories] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [quantities, setQuantities] = useState({});
  const [errors, setErrors] = useState({});
  const [units, setUnits] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState({});
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${baseURL}/manage-items/active`);
        const data = await response.json();
        setCategories(data.data || []);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    const fetchUnits = async () => {
      try {
        const response = await fetch(`${baseURL}/manageunit/list/active`);
        const data = await response.json();
        const unitOptions = (data?.data || []).map(unit => ({
          value: unit.sno,
          label: unit.unitslug_name,
        }));
        setUnits(unitOptions);
      } catch (error) {
        console.error('Error fetching units:', error);
      }
    };

    fetchUnits();
    fetchCategories();
  }, []);

  const formattedOptions = categories.map((item) => ({
    value: item.sno,
    label: item.item_name,
  }));

  const handleSelectChange = (selectedOption, catIndex, rowIndex) => {
    const key = `${catIndex}-${rowIndex}`;
    setSelectedItems(prev => ({ ...prev, [key]: selectedOption }));
    setErrors(prev => ({ ...prev, [key]: { ...prev[key], item: null } }));
  };

  const handleQuantityChange = (e, catIndex, rowIndex) => {
    const key = `${catIndex}-${rowIndex}`;
    const val = e.target.value;
    setQuantities(prev => ({ ...prev, [key]: val }));
    setErrors(prev => ({ ...prev, [key]: { ...prev[key], quantity: null } }));
  };

  const handleUnitChange = (selectedOption, catIndex, rowIndex) => {
    const key = `${catIndex}-${rowIndex}`;
    setSelectedUnits(prev => ({ ...prev, [key]: selectedOption }));
    setErrors(prev => ({ ...prev, [key]: { ...prev[key], unit: null } }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const productId = productData?.product_id;
    if (!productId) {
      // alert("Product ID is missing.");
      return;
    }

    const itemQuantitiesMap = {};
    const newErrors = {};
    let hasError = false;

    productData?.item_category_list?.categories?.forEach((category, catIndex) => {
      Array.from({ length: category.count }).forEach((_, rowIndex) => {
        const key = `${catIndex}-${rowIndex}`;
        const selected = selectedItems[key];
        const quantity = quantities[key];
        const selectedUnit = selectedUnits[key];

        if (!selected) {
          newErrors[key] = { ...(newErrors[key] || {}), item: "Item is required" };
          hasError = true;
        }
        if (!quantity || Number(quantity) <= 0) {
          newErrors[key] = { ...(newErrors[key] || {}), quantity: "Quantity must be greater than 0" };
          hasError = true;
        }
        if (!selectedUnit) {
          newErrors[key] = { ...(newErrors[key] || {}), unit: "Unit is required" };
          hasError = true;
        }

        if (selected?.value && quantity && Number(quantity) > 0 && selectedUnit) {
          const uniqueKey = `${category.id}-${selected.value}`;
          if (itemQuantitiesMap[uniqueKey]) {
            itemQuantitiesMap[uniqueKey].quantity += Number(quantity);
          } else {
            itemQuantitiesMap[uniqueKey] = {
              list_id: category.id,
              item_name: selected.value,   // Send sno/id here, not label
              quantity: Number(quantity),
              unit: selectedUnit.value,    // Send sno/id here, not label
            };
          }
        }
      });
    });

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    const itemQuantities = Object.values(itemQuantitiesMap);

    if (itemQuantities.length === 0) {
      // alert("Please select at least one item and quantity.");
      return;
    }

    try {
      const response = await axios.post(
        `${baseURL}/manage-products/${productId}/item-quantity`,
        { item_quantities: itemQuantities },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200) {
        // alert("Item quantities updated successfully.");
        onClose();
        window.location.reload();
      } else {
        // alert("Failed to update item quantities.");
      }
    } catch (error) {
      // alert("An error occurred: " + (error.response?.data?.message || error.message));
    }
  };

  useEffect(() => {
    if (
      productData?.item_category_list?.categories &&
      productData?.item_quantity &&
      categories.length > 0 &&
      units.length > 0
    ) {
      const prefilledItems = {};
      const prefilledQuantities = {};
      const prefilledUnits = {};

      productData.item_category_list.categories.forEach((category, catIndex) => {
        const existingItems = productData.item_quantity.filter(
          (item) => item.list_id === category.id
        );

        existingItems.forEach((item, rowIndex) => {
          const key = `${catIndex}-${rowIndex}`;
          const matched = categories.find((c) => c.item_name === item.item_name);
          const matchedUnit = units.find(
            (u) => u.label.toLowerCase() === item.unit?.toLowerCase()
          );

          if (matched) {
            prefilledItems[key] = {
              value: matched.sno,
              label: matched.item_name,
            };
            prefilledQuantities[key] = item.quantity;

            if (matchedUnit) {
              prefilledUnits[key] = matchedUnit;
            }
          }
        });
      });

      setSelectedItems(prefilledItems);
      setQuantities(prefilledQuantities);
      setSelectedUnits(prefilledUnits);
    }
  }, [productData, categories, units]);

  return (
    <Modal show={show} size="lg">
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Item Quantity</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-4 d-flex align-items-center gap-3">
              <LightGallery speed={500} plugins={[lgThumbnail, lgZoom]}>
                <div data-src={productData?.product_image || break_box} className="border rounded px-1 py-0">
                  <img
                    src={productData?.product_image || break_box}
                    alt="Product"
                    className="cursor-pointer w-60px h-60px"
                  />
                </div>
              </LightGallery>

              <div>
                <label className="text-black font-w400 fs-5">{productData?.product_name}</label>
                <div className="d-block">
                  <label className="text-black font-w400 fs-7">Item Category</label>
                  <Badge bg="warning" className="text-white fs-8 py-0 px-1 ms-2 rounded-pill">
                    {productData?.item_category_list?.total_category_list || '0'}
                  </Badge>
                  <label className="text-black me-2 ms-2">|</label>
                  <label className="text-black font-w400 fs-7">Item Count</label>
                  <Badge bg="success" className="text-white fs-8 py-0 px-1 ms-2 rounded-pill">
                    {productData?.item_category_list?.total_count || '0'}
                  </Badge>
                </div>
              </div>
            </div>
          </div>

          <div className="row scroll-y mh-350px py-2">
            {productData?.item_category_list?.categories?.map((category, catIndex) => (
              <div key={catIndex} className="col-lg-12 mb-4">
                <label className="text-red font-w600 fs-4 mb-3">
                  {category.item_category_name}
                  <Badge bg="badge-circle" className="badge-outline-info ms-2 fw-bold fs-8">
                    {category.count}
                  </Badge>
                </label>

                {Array.from({ length: category.count }).map((_, rowIndex) => {
                  const key = `${catIndex}-${rowIndex}`;
                  const selected = selectedItems[key];
                  const error = errors[key] || {};
                  const selectedUnit = selectedUnits[key];

                  return (
                    <div key={rowIndex} className="col-lg-12 mb-3">
                      <div className="row">
                        <div className="col-lg-7 mb-4">
                          <label className="text-black font-w500 fs-7">
                            Item<span className="required">*</span>
                          </label>
                          <Select
                            placeholder="Select Item"
                            options={formattedOptions}
                            onChange={(option) => handleSelectChange(option, catIndex, rowIndex)}
                            value={selected || null}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                          {error.item && <small className="text-danger">{error.item}</small>}
                        </div>

                        <div className="col-lg-3">
                          <label className="text-black font-w500 fs-7">
                            Quantity<span className="required">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Quantity"
                            min="1"
                            value={quantities[key] || ""}
                            onChange={(e) => handleQuantityChange(e, catIndex, rowIndex)}
                          />
                          {error.quantity && <small className="text-danger">{error.quantity}</small>}
                        </div>

                        <div className='col-lg-2'>
                          <label className="text-black font-w500 fs-7">
                            Unit<span className="required">*</span>
                          </label>
                          <Select
                            placeholder="Select Unit"
                            options={units}
                            onChange={(option) => handleUnitChange(option, catIndex, rowIndex)}
                            value={selectedUnit || null}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                          {error.unit && <small className="text-danger">{error.unit}</small>}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>

          <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={handleSubmit}>Create Item Quantity</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddItemQuantity;
